import React from 'react';

import Icon from '../../../../components/Icon';

interface OperatorInfoProps {
  operatorName?: string;
  bookingUrl: string | null;
  operatorSearchUrl: string;
  className?: string;
}

const OperatorInfo = ({
  operatorName = '',
  bookingUrl,
  operatorSearchUrl,
  className = '',
}: OperatorInfoProps): JSX.Element => (
  <span className={className}>
    {bookingUrl ? (
      <a
        href={bookingUrl}
        target="_blank"
        rel="noopener noreferrer"
        title="Ссылка на заявку у ТО"
      >
        {operatorName || 'Ссылка на заявку у ТО'}
      </a>
    ) : (
      <span>{operatorName}</span>
    )}
    {operatorSearchUrl && (
      <a
        href={operatorSearchUrl}
        target="_blank"
        rel="noopener noreferrer"
        title="Ссылка на поиск у ТО"
      >
        <Icon type="arrow-right-top" />
      </a>
    )}
  </span>
);

export default OperatorInfo;
